import { Controller } from "@hotwired/stimulus"

// ファンド決算フォームの上に、1口あたり償還金 / 1口あたり分配金 / 雑損益 を
// 入力に応じてライブで描画する。端数はすべて切り捨て。
export default class extends Controller {
  static targets = [
    "startDate", "endDate", "redemptionSource", "distributionSource",
    "perUnitRedemption", "perUnitDistribution", "distributionYield", "miscPL", "days",
  ]
  static values = { investedUnits: Number, unitAmount: Number }

  connect() {
    this.update()
  }

  update() {
    const units = this.investedUnitsValue
    const unitAmount = this.unitAmountValue
    const redemption = this.numberFrom(this.redemptionSourceTarget)
    const distribution = this.numberFrom(this.distributionSourceTarget)
    const days = this.computeDays()

    const perRedemption = units > 0 ? Math.floor(redemption / units) : 0
    const perDistribution = units > 0 ? Math.floor(distribution / units) : 0
    const miscPL = (redemption - perRedemption * units) + (distribution - perDistribution * units)
    // 年率換算: 期間あたり利回り × (365 / 日数)
    const annualYieldPct = (unitAmount > 0 && days > 0)
      ? (perDistribution / unitAmount) * (365 / days) * 100
      : 0

    this.perUnitRedemptionTarget.textContent = perRedemption.toLocaleString()
    this.perUnitDistributionTarget.textContent = perDistribution.toLocaleString()
    this.distributionYieldTarget.textContent = annualYieldPct.toFixed(2)
    this.miscPLTarget.textContent = miscPL.toLocaleString()
    this.daysTarget.textContent = days.toLocaleString()
  }

  // 入力欄の値を整数にする。comma-number controller が入れたカンマは取り除く。
  numberFrom(target) {
    return parseInt(target.value.replace(/\D/g, ""), 10) || 0
  }

  // 両端入れ (end - start + 1) で日数を返す。値が揃わなければ 0。
  computeDays() {
    const startStr = this.startDateTarget.value
    const endStr = this.endDateTarget.value
    if (!startStr || !endStr) return 0
    const start = new Date(startStr)
    const end = new Date(endStr)
    const diff = Math.round((end - start) / (24 * 60 * 60 * 1000)) + 1
    return diff > 0 ? diff : 0
  }
}
